import React from "react";
import { Grid, TextField, Typography, Box } from "@mui/material";

const StepClientDetails = ({ data, onChange }) => {
  const handleChange = (e) => {
    onChange({ ...data, [e.target.name]: e.target.value });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Client Details</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Client Name"
            name="clientName"
            value={data.clientName || ""}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Client Email"
            name="clientEmail"
            type="email"
            value={data.clientEmail || ""}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Phone (Optional)"
            name="clientPhone"
            value={data.clientPhone || ""}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Business Name (Optional)"
            name="businessName"
            value={data.businessName || ""}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Address (Optional)"
            name="clientAddress"
            value={data.clientAddress || ""}
            onChange={handleChange}
            multiline
            rows={2}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StepClientDetails;
